import { 
  LabelCell,
  DescriptionCell, 
  PropertyButtons,
} from "../../../shared/styles";
import { CustomLabel, FlexContainer } from "@mindmemobile/mm-shared-global";
import React, { FC } from "react";
import { ProductAttributesModel } from "../../../shared/models";

type IProps = {
  attributes: ProductAttributesModel[] | null;
};

const ItemAttributeSection: FC<IProps> = ({ attributes }) => {
  if (!attributes || attributes.length === 0) return null;
  const row = (label: string, rightColumn: string | React.ReactNode): React.ReactNode => {
      return (
          <FlexContainer className="label-description-row">
              <LabelCell>
                  <CustomLabel>{label}</CustomLabel>
              </LabelCell>
              <DescriptionCell>{rightColumn}</DescriptionCell>
          </FlexContainer>
      );
  };

  return (
      <>
          <CustomLabel fontSize="20px" fontWeight="600" margin="30px 0px 30px">
              Attributes
          </CustomLabel>

          {attributes &&
              attributes.map((attribute) => {
                  return (
                      <React.Fragment key={attribute.name}>
                          {row(
                              attribute.name,
                              <FlexContainer spacing={10}>
                                  {attribute.options &&
                                      attribute.options.map((option) => {
                                          return (
                                              <PropertyButtons key={option.name} maxWidth="400px" width="auto">
                                                  {option.name}
                                              </PropertyButtons>
                                          );
                                      })}
                              </FlexContainer>,
                          )}
                      </React.Fragment>
                  );
              })}
      </>
  );
};
export default ItemAttributeSection;
